import React from "react"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import { logout } from "../../redux/actionCreators/auth"
import { Route } from "react-router"

const UnAuthenticatedRoute = ({
  component: Component,
  isAuthenticated,
  user,
  logout,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated ? (
        props.history.push("/dashboard")
      ) : (
        <Component {...props}></Component>
      )
    }
  />
)

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
})

export default connect(mapStateToProps, { logout })(UnAuthenticatedRoute)
